<template>
  <div>
    <Header />

    <div class="personalServices">
      <Nav />
      <!-- <div class="container">

      </div> -->
      <LoginForm
        title="社会团体服务"
        :pics="['/static/socialGroupServices1.png']"
        description="中华人民共和国境内的任何合法社会公众组织及专业领域服务组织（比如专业人才协会、行业协会等），均可申请并经平台查证后，获得溯源优才平台的合作组织认定，平台提供基础管理工具，也提供相关业务的订制化增信服务。"
      />
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Nav from "@/components/Nav.vue";
import LoginForm from "../../components/LoginForm.vue";
export default {
  components: { Header, Nav, Footer, LoginForm }
};
</script>

<style lang="scss" scoped>
.personalServices {
  background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/socialGroupServices_bg.png") no-repeat;
  background-size: cover;
  padding-bottom: 70px;
  .nav {
    background: #29447c;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/SocialGroupServices/index.vue